import React, { useState } from "react";
import { motion } from "framer-motion";

const DEFAULT_IMG = "/images/document-logo.png";

const CategoryItem = ({ name, image, onClick }) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const [imgError, setImgError] = useState(false);

  const src = !imgError && image ? image : DEFAULT_IMG;

  return (
    <motion.button
      type="button"
      onClick={onClick}
      aria-label={`Danh mục ${name}`}
      // Hiệu ứng mount nhẹ để grid “thở” hơn
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.18 }}
      // Micro-interactions
      whileHover={{ y: -2, scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className="
        group relative flex h-full w-full flex-col items-center
        rounded-2xl bg-white/90 p-3 shadow-sm ring-1 ring-gray-100
        transition-all duration-200
        hover:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-300
      "
    >
      {/* Icon wrapper */}
      <div
        className="
          relative mt-1 flex h-14 w-14 items-center justify-center
          rounded-full bg-gradient-to-br from-blue-50 to-indigo-50
          ring-1 ring-blue-100
        "
      >
        {/* Skeleton shimmer khi ảnh chưa load */}
        {!imgLoaded && (
          <span
            className="absolute inset-0 animate-pulse rounded-full bg-gray-100"
            aria-hidden="true"
          />
        )}

        <img
          src={src}
          loading="lazy"
          alt="" /* decorative */
          onLoad={() => setImgLoaded(true)}
          onError={() => setImgError(true)}
          className={`
            h-10 w-10 object-contain transition-opacity duration-200
            ${imgLoaded ? "opacity-100" : "opacity-0"}
          `}
        />
      </div>

      {/* Tên danh mục */}
      <span
        className="
          mt-3 line-clamp-2 max-w-[95%] text-center text-[13.5px]
          font-medium tracking-tight text-slate-800
          group-hover:text-slate-900
        "
      >
        {name}
      </span>

      {/* Viền gradient mờ khi hover (nhẹ nhàng, không quá rực) */}
      <span
        aria-hidden="true"
        className="
          pointer-events-none absolute inset-0 rounded-2xl
          opacity-0 transition-opacity duration-200
          group-hover:opacity-100
          [background:radial-gradient(100%_100%_at_50%_0%,rgba(59,130,246,0.12),rgba(99,102,241,0.06)_50%,transparent)]
        "
      />
    </motion.button>
  );
};

export default CategoryItem;
